"use client";

import NextImage, { type ImageProps as NextImageProps } from "next/image";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

import { WhatsIncluded as WhatsIncludedComponent } from "@/composite/WhatsIncluded";
import type { ProductsResponse } from "@/domain/product";
import type { ProductReference } from "@/types";
import type { WhatsIncluded } from "@/types/references";
import { resolveImageProps } from "@/app/utilities/images";

import styles from "./styles.module.scss";

interface WhatsIncludedBlockClientProps extends WhatsIncluded {
	productsData: ProductReference[];
	productsResponse: ProductsResponse;
}

/**
 * Whats Included block component
 */
export function WhatsIncludedBlock({
	productsData,
	productsResponse,
	...props
}: WhatsIncludedBlockClientProps): JSX.Element {
	if (productsResponse?.type === "failure") {
		throw new Error(productsResponse.message);
	}

	return (
		<div className={styles["whats-included"]}>
			<WhatsIncludedComponent<NextImageProps, NextLinkProps>
				heading={{
					children: props.section_headline,
					tag: props.heading_tag
				}}
				items={
					productsData?.map((product) => {
						const productData = productsResponse?.products?.find(
							({ sku }) => sku === product.sku
						);

						return {
							image: {
								...resolveImageProps("1:1"),
								component: NextImage,
								src: productData?.image ?? "",
								alt: productData?.name ?? ""
							},
							cta: {
								children: product?.title ?? "",
								href:
									product?.meta_data?.canonical_url?.href ??
									"",
								component: NextLink
							},
							rating: {
								rating: productData?.starsRating ?? 0,
								label: productData?.numRatings
									? `(${productData?.numRatings})`
									: ""
							},
							price: {
								display: productData?.salePrice ?? 0
							}
						};
					}) ?? []
				}
			/>
		</div>
	);
}
